import React from "react";
import { Link } from "react-router-dom";

const CarouselItem = ({ imgUrl, title, path }) => {
  return (
    <div className="carousel-card">
      <img src={imgUrl} alt={title} className="carousel-image" />
      <div className="carousel-overlay">
        <h3 className="carousel-title">{title}</h3>
        <Link to={path}>
          <button className="carousel-button">Explore more →</button>
        </Link>
      </div>
    </div>
  );
};

export default CarouselItem;
